module.exports = __webpack_public_path__ + "media/images/creator/monitor/limited@2x-2af4e7dfdffcd8025e85ed64cd824b4e.png";